export default {
  init_notification: ({ commit }, payload) => {
    commit('load_notification', payload)
  },
  clear_notification: ({ commit }) => {
    const empty_modal = {
      isVisible: false,
      header: '',
      body: ''
    }

    commit('clear_notification', empty_modal)
  }
}
